import script from "./SideHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SideHeader.vue?vue&type=style&index=0&id=31787d6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31787d6a"]])

export default __exports__